import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IProgressUpdateSplitPanelState,
  ProgressUpdateCategory,
} from "./definitions";

const initialState: IProgressUpdateSplitPanelState = {
  isOpen: false,
  category: null,
};

export const progressUpdateSplitPanelSlice = createSlice({
  name: "progressUpdateSplitPanel",
  initialState,
  reducers: {
    openProgressUpdate: (
      state,
      action: PayloadAction<ProgressUpdateCategory>,
    ) => {
      state.isOpen = true;
      state.category = action.payload;
    },
    closeProgressUpdate: (state) => {
      state.isOpen = false;
      state.category = null;
    },
  },
});

export const { openProgressUpdate, closeProgressUpdate } =
  progressUpdateSplitPanelSlice.actions;

export default progressUpdateSplitPanelSlice.reducer;
